import React, { useState } from "react";
import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useDispatch } from "react-redux";
import { showAlert } from "redux/actions/setAppActions";

export const InvitePsychologistModal = ({ schoolId, onClose, onSuccess }) => {
    const { t } = useTranslation("schools");
    const dispatch = useDispatch();
    const [login, setLogin] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!login.trim()) {
            dispatch(showAlert({ type: "error", text: t("invite_enter_login") }));
            return;
        }

        setLoading(true);
        try {
            const { data } = await axios.post(`schools/${schoolId}/invite`, { login: login.trim() });
            dispatch(showAlert({ type: "success", text: data.message || t("invite_success") }));
            setLogin("");
            onSuccess && onSuccess();
            onClose();
        } catch (error) {
            const errorMessage = error.response?.data?.message || t("invite_error");
            dispatch(showAlert({ type: "error", text: errorMessage }));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-messages">
            <div className="page popup-tg" style={{ paddingTop: 40 }}>
                <div className="popup-tg-close" onClick={onClose}>
                    <IoClose />
                </div>

                <h3 style={{ margin: 0, textAlign: "center", marginBottom: 24 }}>
                    {t("invite_psychologist")}
                </h3>

                <form onSubmit={handleSubmit}>
                    <div className="input-field">
                        <input
                            id="psychLogin"
                            type="text"
                            name="login"
                            placeholder={t("invite_login_placeholder")}
                            onChange={(e) => setLogin(e.target.value)}
                            value={login}
                            disabled={loading}
                            autoFocus
                        />
                        <label htmlFor="psychLogin">{t("invite_login_label")}</label>
                    </div>

                    <div className="modal-messages__buttons" style={{ marginTop: 24 }}>
                        <button type="button" onClick={onClose} disabled={loading}>
                            {t("cancel")}
                        </button>
                        <button type="submit" disabled={!login.trim() || loading}>
                            {loading ? t("sending") : t("invite_send")}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
